import React, { useEffect, useState } from "react";
import { Button, ListItem, Typography, useTheme, Box, CircularProgress, Select, MenuItem, FormControl } from "@mui/material";
import { submitMap, useMapError } from "../../../state/map";
import { useAppDispatch } from "@/state/types";
// Price fetching is now handled automatically by Redux middleware
import { usePriceFormatted, usePriceIsLoading, useCurrency, setCurrency, usePrice } from "../../../state/image";
import { Currency } from "../../../types";

export const SubmitStep = () => {
  const theme = useTheme();
  const [disable, setDisable] = useState(false);
  const dispatch = useAppDispatch();
  const error = useMapError();
  const priceFormatted = usePriceFormatted();
  const price = usePrice();
  const priceIsLoading = usePriceIsLoading();
  const currency = useCurrency();

  const onCurrencyChange = (newCurrency: Currency) => {
    dispatch(setCurrency(newCurrency));
  }

  useEffect(() => {
    if (disable) {
      const task = setTimeout(() => setDisable(false), 10_000);
      return () => clearTimeout(task);
    }
  }, [disable, setDisable])

  return (
    <>
      <ListItem
        style={{
          backgroundColor: theme.palette.background.default,
          display: "flex",
          justifyContent: "start",
          flexWrap: "wrap",
        }}
      >
        <div style={{ width: "100%" }}>
          {/* Error Message */}
          {error && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body1" color="error">{error}</Typography>
            </Box>
          )}
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
                border: '1px solid',
                borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                flex: '0 0 auto',
                mb: 2
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2 }}>
                <FormControl size="small" sx={{ minWidth: 80 }}>
                  <Select
                    value={currency}
                    onChange={(e) => onCurrencyChange(e.target.value as Currency)}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        border: 'none'
                      },
                      '& .MuiSelect-select': {
                        py: 0.5,
                        fontSize: '0.875rem',
                        fontWeight: 500
                      }
                    }}
                  >
                    {Object.values(Currency).map((curr) => (
                      <MenuItem key={curr} value={curr}>
                        {curr}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                
                {priceIsLoading ? (
                  <CircularProgress size={20} />
                ) : (
                  <Typography variant="h6" fontWeight={600} color="primary">
                    {price === 0 ? "Free" : priceFormatted || 'Calculating...'}
                  </Typography>
                )}
              </Box>
              <Button variant="contained" onClick={() => {setDisable(true); dispatch(submitMap())}} disabled={!!error || disable}>
                Create
              </Button>
            </Box>
        </div>
      </ListItem>
    </>
  );
};
